// import { getLocaleTime } from '../../utils.js'
const fb = require('../../firebaseConfig.js')
const algolia = require('../configs/algoliaConfig.js')

export default {
    state: {
        invoices: [],
        invoice: {},
        invoiceFilters: {},
		invoicesPagination: { page: 0, hitsPerPage: 10, totalRecords: 0, totalPages: 0, showLoadMore: true, autoRefresh: false }
    },
    getters: {
        invoice: (state) => {
            return state.invoice
        },
        invoices: (state) => {
            return state.invoices
        },
        invoicesPagination: (state) => {
            return state.invoicesPagination
        },
        invoiceFilters: (state) => {
            return state.invoiceFilters
        },
    },
    mutations: {
        setInvoices(state, val) {
            state.invoices = val
        },
        setInvoice(state, val) {
            state.invoice = val
        },
        setInvoicesPagination(state, val) {
            state.invoicesPagination = val
        },
        setInvoiceFilters(state, val) {
            state.invoiceFilters = val
        },
        setDefaultInvoicesPagination(state) {
            state.invoicesPagination = { page: 0, hitsPerPage: 10, totalRecords: 0, totalPages: 0, showLoadMore: true, autoRefresh: false };
        }
    },
    actions: {
        createInvoice({getters}, payload) {
            let invoice = {}
            invoice.number = payload.number
            invoice.purchaseOrderNumber = payload.purchaseOrderNumber
            invoice.purchaseOrderId = payload.purchaseOrderId
            invoice.costCenterCode = payload.costCenterCode
            invoice.costCenterName = payload.costCenterName
            invoice.providerName = payload.providerName
            invoice.providerCode = payload.providerCode
            invoice.products = []
            invoice.invoiceDate = payload.invoiceDate
            invoice.invoiceTimestamp = fb.fromDate(payload.invoiceDate)
            invoice.paymentDate = payload.paymentDate
            invoice.paymentTimestamp = fb.fromDate(payload.paymentDate)
            invoice.createdBy = getters.userId

            payload.products.forEach((product) => {
                if (product.invoiced == true) {
                    invoice.products.push(product)
                }
            })

            let documentPath = 'Invoices/' + payload.purchaseOrderNumber + '-' + payload.number + '/'
            let storageRef = fb.storage.ref()
            fb.invoicesCollection.add(invoice).then((docRef) => {
                console.log(docRef.id)
                let metadata = {
                    customMetadata: {
                        documentId: docRef.id,
                        type: '',
                        rootPath: documentPath
                    }
                }

                let invoiceReference = storageRef.child(documentPath + payload.invoiceDocument.name)
                metadata.customMetadata.type = 'Invoice'
                invoiceReference.put(payload.invoiceDocument, metadata).then(snapshot => {
                    snapshot.ref.getDownloadURL().then(function(downloadURL) {
                        fb.invoicesCollection.doc(docRef.id).set({
                            invoiceDocument: {
                                name: snapshot.ref.name,
                                fullPath: snapshot.ref.fullPath,
                                downloadURL: downloadURL,
                                type: 'Invoice'
                            }
                        }, {merge: true})
                    });
                    // console.log(snapshot.ref)
                })

                let shippingDocumentReference = storageRef.child(documentPath + payload.shippingDocument.name)
                metadata.customMetadata.type = 'ShippingDocument'
                shippingDocumentReference.put(payload.shippingDocument, metadata).then(snapshot => {
                    snapshot.ref.getDownloadURL().then(function(downloadURL) {
                        fb.invoicesCollection.doc(docRef.id).set({
                            shippingDocument: {
                                name: snapshot.ref.name,
                                fullPath: snapshot.ref.fullPath,
                                downloadURL: downloadURL,
                                type: 'ShippingDocument'
                            }
                        }, {merge: true})
                    });
                })
            })

        },
        async fetchInvoices({commit,getters}) {
            const index = algolia.client.initIndex(algolia.indexes.invoices)
            let pagination = getters.invoicesPagination
            let invoices = {}
            let invoiceFilters = getters.invoiceFilters

            let keywordSearch = ''
            let filters = {
                page: pagination.page,
                hitsPerPage: pagination.hitsPerPage,
            }
            if (invoiceFilters.keyword != '') {
                keywordSearch = invoiceFilters.keyword
            }

            if (invoiceFilters.paymentDate != '') {
                filters.filters = `paymentTimestamp = ${fb.fromDate(invoiceFilters.paymentDate).seconds * 1000}`

            }

            index.search(keywordSearch, filters).then(({hits, nbHits, nbPages}) => {
                console.log(hits, nbHits, nbPages)
                pagination.totalRecords = nbHits
                pagination.totalPages = nbPages
                pagination.autoRefresh = false

                if (pagination.page == pagination.totalPages-1) {
                    pagination.showLoadMore = false
                }

                if (pagination.page == 0) {
                    invoices = hits
                } else {
                    invoices = getters.invoices.concat(hits)
                }

                commit('setInvoicesPagination', pagination)
                commit('setInvoices', invoices)
            })

        }
    }
}